
import { Component, Prop } from "vue-property-decorator";
import Highcharts from "highcharts";
import { TypedVue } from "@/store/types";
import { TraitChartSeriesProvider, TraitChartCompactOptionsProvider } from "@/lib/charts/TraitChart";
import { RadarChartTheme } from "@/lib/charts/HighChartThemes";

type Priority = "high" | "mixed" | "low";

@Component
export default class ElraReport8HeroRadar extends TypedVue {
  @Prop({ required: true }) traitScores!: Record<string, number>;
  @Prop({ required: true }) traitPriorities!: Record<string, Priority>;
  @Prop({ default: "" }) color!: string;
  @Prop({ required: true }) theme!: string;

  get chartOptions(): Highcharts.Options {
    const seriesProvider = TraitChartSeriesProvider({
      showNames: false,
      theme: this.theme,
      fourGroup: true,
    });

    const syntheticItem = {
      id: "hero-radar",
      color: this.color,
      selected: true,
      data: { traitScores: this.traitScores },
    };

    const series = seriesProvider(syntheticItem, () => "");

    // Decorate each point with `priority` so the compact tooltip can render the chip.
    const decoratedData = (series.data || []).map((pt) => {
      const trait = (pt as { trait?: string }).trait;
      const priority = trait ? this.traitPriorities[trait] : undefined;
      return { ...(pt as Record<string, unknown>), priority };
    });

    // Override point.events from the shared series provider. Its mouseOver/mouseOut
    // assume x-axis labels exist (full chart) and throw on the compact chart
    // (labels.enabled: false → no labelGroup.div). The default Highcharts hover behavior
    // gives us the tooltip we want without the label-fade side effects we don't need here.
    const decoratedSeries = {
      ...series,
      data: decoratedData,
      point: { events: {} },
    } as Highcharts.SeriesOptionsType;

    const compactOptions = TraitChartCompactOptionsProvider({
      showNames: false,
      theme: this.theme,
      fourGroup: true,
      resourceLookup: (key: string) => this.$t(key).toString(),
    });

    return {
      ...RadarChartTheme,
      ...compactOptions,
      series: [decoratedSeries],
    };
  }
}
